import { createContext, useContext } from 'react';

export type DialogWindowedControls = {
  windowed: boolean;
  toggleWindowed: () => void;
};

export const DialogWindowedControlsContext = createContext<
  DialogWindowedControls | undefined
>(undefined);

export const useDialogWindowedControls = () =>
  useContext(DialogWindowedControlsContext);
